<!-- crud asignar url de la api URL="url de la api" titulo="un titulo para la pestaña de la pagina" [dato]="variable que contiene el formulario]-->
<app-formulario #ctrl URL="venta" titulo="Venta" [dato]="dato"></app-formulario>

<!-- Menu principal "-->
<sistema-menu *ngIf="!persona"></sistema-menu>

<form name="form" novalidate [formGroup]="dato" (ngSubmit)="enviar();">
    <div class="contenedor columns " [style]="!persona ? 'overflow-y:auto; overflow-x: hidden; height:94vh;' : ''">

        <!-- apartado de movimientos_articulos -->
        <div class="column" style="padding:0em;">
            <div style="background: #FFF; border-radius: 0em; ">

                <section class="hero is-primary">
                    <div class="hero-body">
                        <nav class="level columns">
                            <!-- Left side -->
                            <div class="level-left column is-3">
                                <div class="level-item">
                                    <p class="title">
                                        <span *ngIf="!ctrl.cargando || !cargando" class="icon is-medium">
                                            <i class="fa fa-edit"></i>
                                        </span>
                                        <span *ngIf="ctrl.cargando || cargando" class="icon is-medium">
                                            <i class="fa fa-refresh fa-spin"></i>
                                        </span> Artículos
                                    </p>
                                </div>
                            </div>

                            <!-- Right side -->
                            <div class="level-right column">
                                <div class="level-item">
                                    <div class="field is-grouped" style=" width: 100%; ">
                                        <div class="control has-icons-left is-expanded" *ngIf="codigo_barras_activo">
                                            <input autofocus class="input is-success is-medium" (keydown)="buscar_articulo($event)" id='buscarArticuloVenta' type="text" placeholder="Escanea el codigo de barra, o cambia la forma de busqueda">
                                            <span class="icon is-medium is-left">
                                                <i class="fa fa-barcode"></i>
                                            </span>
                                        </div>
                                        <div class="control has-icons-left is-expanded" *ngIf="!codigo_barras_activo">
                                            <input autofocus autocomplete="off" ngui-auto-complete [source]="observableSource.bind(this)" [list-formatter]="autocompleListFormatter" [close-on-focusout]="false"
                                                id='buscarArticuloVenta' value-property-name="clave" display-property-name="nombre"
                                                path-to-data="" loading-text="Cargando..." no-match-found-text="No hay resultados."
                                                (valueChanged)="select_articulo_autocomplete($event)" min-chars="1" class="input is-success is-medium"
                                                type="text" placeholder="Escribe el nombre del producto, o cambia la forma de busqueda">
                                            <span class="icon is-medium is-left">
                                                <i class="fa fa-search"></i>
                                            </span>
                                        </div>
                                        <div class="control">
                                            <div class="b-checkbox is-info is-circular is-medium">
                                                <input id="codigo_barras_activo_t" name="codigo_barras_activo" value="true" class="styled" type="radio" (click)="cambiar_busqueda()"
                                                    [checked]="codigo_barras_activo">
                                                <label for="codigo_barras_activo_t">
                                                    Buscar por codigo de barras
                                                </label>
                                                <div style="height: 12px;"></div>
                                                <input id="codigo_barras_activo_f" name="codigo_barras_activo" value="false" class="styled" type="radio" (click)="cambiar_busqueda()"
                                                    [checked]="!codigo_barras_activo">
                                                <label for="codigo_barras_activo_f">
                                                    Buscar por texto libre
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </nav>
                    </div>
                </section>
                <div class="is-fullwidth has-text-centered" *ngIf="!ctrl.datosCargados">
                    <br>
                    <span class="tag is-primary is-large ">
                        <span class="icon">
                            <i class="fa fa-refresh fa-spin"></i>
                        </span> &nbsp;
                        <span>Cargando...</span>
                    </span>
                </div>
                <section>
                    <div class="notification is-warning" *ngIf="!caja_abierta && ctrl.configuracion.sucursal.notificar_caja_cerrada">
                        ¡No se ha detectado ninguna caja abierta!
                        <strong>Puede realizar la venta</strong>, Pero se recomienda que se habra la caja
                        <a class="button is-small" routerLink="../../caja-operacion/nuevo">Abrir una caja</a>
                    </div>
                    <div class="notification is-danger" *ngIf="error_venta">
                        ¡No se completo la venta!
                        <strong>Intente de nuevo</strong>, Si no contacte con soporte
                    </div>
                    <div class="notification is-success" *ngIf="venta_ok">
                        Venta realizada con exito
                        <strong>Puede seguir vendiendo</strong>
                    </div>

                    <div class="notification is-black" *ngIf="sin_resultado != ''">
                      ¡Mesaje del servidor!
                      <strong>{{sin_resultado}}</strong>
                    </div>

                    <div formArrayName="movimientos_articulos" style="overflow:auto; display:block" [style.height.px]="tamano-225">
                        <div class="box" *ngFor="let val of ctrl.dato.controls.movimientos_articulos.controls;  let i = index;" [ngStyle]="{'background': i%2 == 0 ? 'rgba(230, 230, 232, 0.44)' : 'rgba(237, 242, 243, 0.44)'}">
                            <article class="media" [formGroupName]="i">
                                <div class="media-content">
                                    <div class="content">
                                        <a style="float: right;" class="is-danger" title="Quitar" (click)="ctrl.quitar_form_array(ctrl.dato.controls.movimientos_articulos, i); calcular_importe_articulo();">
                                            <span class="icon has-text-danger fa-2x">
                                                <i class="fa fa-trash"></i>
                                            </span>
                                        </a>
                                        <div class="columns">
                                            <div class="column is-4">
                                                <strong>NOMBRE: </strong> ( {{val.get("articulos").value.codigo_barras}}) {{val.get("articulos").value.nombre}}
                                                &nbsp; Existencia: {{val.get("articulos").value.existencia}}
                                            </div>

                                            <div class="column is-3">
                                                <label class="label">Precio</label>
                                                <div class="control  has-icon has-icon-right">
                                                    <span *ngIf="tieneid">{{val.get("precio_unitario").value}}</span>
                                                    <span *ngIf="ctrl.permisos.indexOf('ArticuloPreciocontroller.index') < 0 && !tieneid">{{val.get("precio_unitario").value}}</span>

                                                    <div class="select" *ngIf="ctrl.permisos.indexOf('ArticuloPreciocontroller.index') > -1 && !tieneid">
                                                        <select class="select" (change)="cambiar_precio($event, i, ctrl.dato.controls.movimientos_articulos.controls)">
                                                            <option *ngFor="let pre of val.get('articulos').value.articulos_precios; let p = index" value="{{p}}">{{ pre.nombre }} {{ pre.precio | currency:ctrl.configuracion.sucursal.moneda:'symbol'
                                                                }}
                                                            </option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="column is-2">
                                                <label class="label">Descuento %</label>
                                                <div class="control  has-icon has-icon-right">

                                                    <input class="input has-text-centered" type="number" step="1" min="0" placeholder="Descuento" formControlName="descuento"
                                                        (change)="cambio_cantidad_articulo(ctrl.dato.controls.movimientos_articulos.controls[i].controls);"
                                                        (keyup)="cambio_cantidad_articulo_key($event, ctrl.dato.controls.movimientos_articulos.controls[i].controls);">

                                                </div>
                                            </div>

                                            <div class="column is-2">
                                                <label class="label">Cantidad</label>
                                                <div class="control  has-icon has-icon-right">
                                                    <input class="input has-text-centered" type="number" step="1" min="1" placeholder="Cantidad" formControlName="cantidad" (change)="cambio_cantidad_articulo(ctrl.dato.controls.movimientos_articulos.controls[i].controls);"
                                                        (keyup)="cambio_cantidad_articulo_key($event, ctrl.dato.controls.movimientos_articulos.controls[i].controls);"
                                                        [ngClass]="!val.controls.cantidad.valid ? 'is-danger' : val.controls.cantidad_restante.value != 0 ?
                                                        'is-warning' : 'is-success'">

                                                    <span class="icon is-small" *ngIf="!val.controls.cantidad.valid">
                                                        <i class="fa fa-warning"></i>
                                                    </span>
                                                    <span class="help is-danger" *ngIf="!val.controls.cantidad.valid">Este campo es requerido.</span>
                                                </div>
                                            </div>

                                            <div class="column is-1">
                                                <label class="label">Importe</label>
                                                <div class="control  has-icon has-icon-right">
                                                    <span class="tag is-success is-medium">{{val.get("precio_con_descuentos").value | currency:ctrl.configuracion.sucursal.moneda:'symbol'}}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div *ngIf="ctrl.configuracion.sucursal.control_lote == 1">
                                            <button (click)="seleccionar_stock(val.get('articulos').value.stocks, i); ctrl.abrirModal('abrirstock');" class="button is-fullwidth is-info"
                                                type="button" *ngIf="val.get('cantidad_restante').value > 0">Seleccionar lote</button>

                                            <table class="table">
                                                <thead>
                                                    <tr>
                                                        <th>Lote</th>
                                                        <th>Caducidad</th>
                                                        <th>Existencia</th>
                                                        <th>Cantidad</th>
                                                        <th></th>
                                                    </tr>
                                                </thead>
                                                <tbody formArrayName="stocks">
                                                    <tr *ngFor="let stck of val.controls.stocks.controls; let x = index;" [formGroupName]="x">
                                                        <td>{{stck.value.lote}}</td>
                                                        <td>{{stck.value.fecha_caducidad}}</td>
                                                        <td>{{stck.value.existencia}}</td>
                                                        <td>
                                                            <p class="control is-expanded  has-icon has-icon-right">
                                                                <input class="input has-text-centered" id="cantidad{{i}}{{x}}" formControlName="cantidad" type="number" placeholder="Cantidad"
                                                                    step="1" min="1" [max]="val.get('stocks').value > 1 ? val.get('cantidad_restante').value : val.get('cantidad').value"
                                                                    (change)="cambio_cantidad_stock(ctrl.dato.controls.movimientos_articulos.controls[i].controls, ctrl.dato.controls.movimientos_articulos.controls[i].controls.stocks.controls, x)"
                                                                    (keyup)="cambio_cantidad_stock_key($event, ctrl.dato.controls.movimientos_articulos.controls[i].controls, ctrl.dato.controls.movimientos_articulos.controls[i].controls.stocks.controls, x)"
                                                                    [ngClass]="!stck.controls.cantidad.valid ? 'is-danger' : stck.controls.cantidad.value > stck.controls.existencia.value ? 'is-warning' : 'is-success'">

                                                                <span class="icon is-small" *ngIf="!stck.controls.cantidad.valid">
                                                                    <i class="fa fa-warning"></i>
                                                                </span>
                                                                <span class="help is-danger" *ngIf="!stck.controls.cantidad.valid">Este campo es requerido.</span>
                                                            </p>
                                                        </td>
                                                        <td>
                                                            <a class="is-danger" title="Quitar" (click)="quitar_stock(ctrl.dato.controls.movimientos_articulos.controls[i].controls.stocks, x, i, stck); ">
                                                                <span class="icon has-text-danger fa-2x">
                                                                    <i class="fa fa-trash"></i>
                                                                </span>
                                                            </a>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </article>
                        </div>
                    </div>

                </section>
            </div>
        </div>

        <!-- datos del cliente y los importes -->
        <div class="column is-one-third" style="padding:0em;">

            <div style="background: #FFF; border-radius: 0em; ">

                <section class="hero is-primary">
                    <div class="hero-head">
                        <nav class="level">
                            <!-- Left side -->
                            <div class="level-left">
                                <div class="level-item">
                                    <p class="title is-4" style=" padding-left: 10px; ">
                                        <span class="icon is-medium">
                                            <i class="fa fa-file-text"></i>
                                        </span> Venta
                                    </p>
                                </div>


                            </div>

                            <!-- Right side -->
                            <div class="level-right">
                                <a class="navbar-item is-primary tooltip" (click)="ctrl.abrirModal('ventas_colas')" id="lista_colas" *ngIf="ctrl.venta?.length > 0">
                                    <span class="icon fa-2x has-text-link">
                                        <i class="fa fa-ticket"></i>
                                    </span>
                                    <span class="tooltiptext">Ventas supspendidas</span>
                                </a>

                                <a class="navbar-item is-primary tooltip" (click)="ctrl.regresar()" *ngIf="!persona">
                                    <span class="icon fa-2x">
                                        <i class="fa fa-arrow-left"> </i>
                                    </span>
                                    <span class="tooltiptext">Regresar</span>
                                </a>

                                <a class="navbar-item is-primary tooltip" (click)="ctrl.cargarDatos()" id='cargar_datos_actualizar' *ngIf="ctrl.id">
                                    <span class="icon fa-2x">
                                        <i class="fa fa-refresh"></i>
                                    </span>
                                    <span class="tooltiptext">Actualizar</span>
                                </a>

                                <a class="navbar-item is-primary tooltip" (click)="reset_form()" *ngIf="!tieneid && !persona">
                                    <span class="icon fa-2x">
                                        <i class="fa fa-eraser"></i>
                                    </span>
                                    <span class="tooltiptext">Limpiar</span>
                                </a>

                                <a class="navbar-item is-primary tooltip" routerLink="{{url_nuevo}}" *ngIf="ctrl.id" >
                                    <span class="icon fa-2x">
                                        <i class="fa fa-file"></i>
                                    </span>
                                    <span class="tooltiptext">Nuevo</span>
                                </a>

                                <button type="button" [ngClass]="{'is-loading': cargando }"
                                  class="navbar-item  tooltip" (click)="enviar_correo()" *ngIf="!persona">
                                  <span class="icon fa-2x has-text-link">
                                    <i class="fa fa-send"></i>
                                  </span>
                                  <span class="tooltiptext">Enviar</span>
                                </button>
                                <button type="button" [ngClass]="{'is-loading': cargando }" class="navbar-item  tooltip" (click)="enviar_correo(true)" *ngIf="!persona">
                                  <span class="icon fa-2x has-text-link">
                                    <i class="fa fa-print"></i>
                                  </span>
                                  <span class="tooltiptext">Imprimir prep.</span>
                                </button>

                                <button class="navbar-item  tooltip" type="button" (click)="ctrl.imprimeTicket(json)" *ngIf="reimprimir" id="imprimir_ticket">
                                    <span class="icon fa-2x has-text-info">
                                        <i class="fa fa-print"> </i>
                                    </span>
                                    <span class="tooltiptext">Reimprimir el ticket</span>
                                </button>

                                <button class="navbar-item  tooltip" type="submit" [ngClass]="{'is-loading': cargando}" [disabled]="ctrl.dato.invalid || cargando"
                                    >
                                    <span class="icon fa-2x has-text-success">
                                        <i class="fa fa-save"> </i>
                                    </span>
                                    <span class="tooltiptext">Guardar</span>
                                </button>

                                <button class="navbar-item  tooltip" type="button" (click)="ctrl.guardar_lista_colas()" [ngClass]="{'is-loading': cargando}"
                                    *ngIf="!tieneid && !persona">
                                    <span class="icon fa-2x has-text-black">
                                        <i class="fa fa-ticket"> </i>
                                        <i class="fa fa-save"> </i>
                                    </span>
                                    <span class="tooltiptext">Suspender</span>
                                </button>
                                &nbsp;

                            </div>
                        </nav>
                    </div>
                </section>

                <div style="padding: 1em;">

                    <!-- cargar los catalogos que se requieran parametro 1 modelo donde se guarda el catalogo, parametro 2 ruta de la api -->
                    <a id="catalogosVenta" (click)="ctrl.cargarCatalogo('clientes', 'cliente?id=1'); ctrl.cargarCatalogo('metodos_pagos', 'tipo-metodo-pago'); ctrl.cargarCatalogo('formas_pagos', 'tipo-forma-pago');"></a>
                    <h3 class="title">
                        <i class="fa fa-file"></i> Datos de la venta
                    </h3>
                    <div class="field">
                        <label class="label">Alumno (opcional): </label>
                        <ng-select2 name="personas_id" [disabled]="persona" [options]="ctrl.optionSelect" [value]="ctrl.dato.controls.personas_id.value" (valueChanged)="ctrl.seleccionarValorSelect2($event, ctrl.dato.controls.personas_id); "
                            [data]="ctrl.clientes"></ng-select2>
                    </div>
                    <div class="field">
                        <label class="label">Cajero (opcional): <span class="help is-link">{{nombreCajero}}</span></label>
                        <div class="field has-addons">
                          <div class="control has-icons-left has-icons-right is-expanded">
                            <input class="input" type="email" placeholder="Clave cajero" [(ngModel)]="cajero" [ngModelOptions]="{standalone: true}">
                            <span class="icon is-left">
                              <i class="fa fa-user"></i>
                            </span>
                          </div>
                          <div class="control">
                            <a class="button is-info" (click)="buscarCajero()">
                              <i class="fa fa-search"> </i> &nbsp; Buscar
                            </a>
                          </div>
                        </div>
                    </div>
                    <div class="field">
                        <label class="label">Comentarios:</label>
                        <p class="control is-expanded  has-icon has-icon-right">
                            <textarea class="textarea" type="text" rows="2" placeholder="Comentarios" formControlName="comentarios"></textarea>
                        </p>
                    </div>

                    <hr>

                    <div class="card">
                        <header class="card-header">
                            <p class="card-header-title">
                                Formas de pago
                            </p>
                            <a class="card-header-icon">
                                <span class="icon fa-2x">
                                    <i class="fa fa-money"></i>
                                </span>
                            </a>
                        </header>
                        <div class="card-content">


                            <div formArrayName="pagos">
                                <div class="content" *ngFor="let item of ctrl.dato.controls.pagos.controls; let i=index">
                                    <div class="box" [formGroupName]="i" [style.background]="item.value.es_abono ? 'gainsboro' : ''">
                                        <article class="media">

                                            <div class="media-content">
                                                <div style="display:flow-root">
                                                    <strong *ngIf="item.value.es_abono" style="float:left">
                                                        ABONO DE PEDIDO
                                                    </strong>
                                                    <a style="float:right" *ngIf="!tieneid && !item.value.es_abono" class="button is-danger is-small" (click)="ctrl.quitar_form_array(ctrl.dato.controls.pagos, i); calcular_importe_articulo();">
                                                        <span class="icon">
                                                            <i class="fa fa-minus"></i>
                                                        </span>
                                                    </a>
                                                </div>
                                                <div class="columns">
                                                    <div class="column is-6">
                                                        <label>Forma de pago: </label>
                                                        <div class="select">
                                                            <select class="select" name="tipos_formas_pagos_id" formControlName="tipos_formas_pagos_id">
                                                                <option *ngFor="let val of ctrl.formas_pagos" value="{{val.id}}">{{ val.nombre }}</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div class="column is-6">

                                                        <label>Pago: </label>
                                                        <p class="control is-expanded  has-icon has-icon-right">
                                                            <input class="input has-text-centered is-success" type="number" step="0.1" min="0" placeholder="Pago" formControlName="importe"
                                                                [ngClass]="{'is-danger': !item.controls.importe.valid}">

                                                            <span class="icon is-small" *ngIf="!item.controls.importe.valid">
                                                                <i class="fa fa-warning"></i>
                                                            </span>
                                                            <span class="help is-danger" *ngIf="!item.controls.importe.valid">Este campo es requerido.</span>
                                                        </p>
                                                    </div>

                                                </div>
                                                <div class="columns">
                                                    <div class="column is-6">
                                                        <label>Paga con: </label>
                                                        <p class="control is-expanded  has-icon has-icon-right" *ngIf="!item.value?.es_abono">

                                                            <input class="input has-text-centered is-warning" (keyup)="validar_cantidad_pago($event, ctrl.dato.controls.pagos.controls[i].controls.paga_con, item.value?.importe, 'min', i); "
                                                                type="number" step="0.1" min="{{item.value?.importe}}"
                                                                placeholder="Paga con" formControlName="paga_con">
                                                        </p>
                                                        <p class="control is-expanded  has-icon has-icon-right" *ngIf="item.value?.es_abono">
                                                            <input class="input has-text-centered is-warning" type="text" placeholder="Paga con" formControlName="paga_con" readonly>
                                                        </p>
                                                    </div>
                                                    <div class="column is-6">
                                                        <label>Cambio: </label>
                                                        <p class="control is-expanded  has-icon has-icon-right">
                                                            <input class="input has-text-centered is-dark" readonly placeholder="Cambio" formControlName="cambio">
                                                        </p>
                                                    </div>
                                                </div>
                                                <div class="columns">
                                                    <div class="column is-12">
                                                        <label>Metodo de pago: </label>
                                                        <div class="select">
                                                            <select class="select" name="tipos_metodos_pagos_id" formControlName="tipos_metodos_pagos_id">
                                                                <option *ngFor="let val of ctrl.metodos_pagos" value="{{val.id}}">{{ val.nombre }}</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </article>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <footer class="card-footer" *ngIf="ctrl.dato.get('subtotal').value > 0 ">
                            <a class="card-footer-item" *ngIf="ctrl.dato.get('valido').value == ''" (click)="agregar_forma_pago(ctrl.dato.controls.pagos, form_pagos); calcular_importe_articulo();">
                                <span class="icon fa-2x has-text-success">
                                    <i class="fa fa-plus"></i>
                                </span>
                                &nbsp;Agregar otro</a>
                            <a class="card-footer-item is-danger" (click)="ctrl.limpiar_form_array(ctrl.dato.controls.pagos); calcular_importe_articulo();">
                                <span class="icon fa-2x has-text-danger">
                                    <i class="fa fa-trash"></i>
                                </span>
                                &nbsp;Limpiar pagos</a>
                        </footer>
                    </div>

                    <nav class="panel" style="font-size:1.5em">
                        <p class="panel-heading">
                            Cobro
                        </p>


                        <a class="panel-block is-active">
                            <span class="panel-icon">
                                <i class="fa fa-money"></i>
                            </span>
                            <div class="columns" style="width:100%">
                                <div class="column is-6">
                                    Subtotal:
                                </div>
                                <div class="column is-6">
                                    {{ctrl.dato.get('subtotal').value | currency:ctrl.configuracion.sucursal.moneda:'symbol'}}
                                </div>
                            </div>
                        </a>
                        <a class="panel-block" *ngIf="ctrl.dato.get('descuento').value > 0">
                            <span class="panel-icon">
                                <i class="fa fa-money"></i>
                            </span>
                            <div class="columns" style="width:100%">
                                <div class="column is-6">
                                    Descuento:
                                </div>
                                <div class="column is-6">
                                    {{ctrl.dato.get('descuento').value | currency:ctrl.configuracion.sucursal.moneda:'symbol'}}
                                </div>
                            </div>
                        </a>
                        <a class="panel-block" *ngIf="ctrl.dato.get('iva').value > 0">
                            <span class="panel-icon">
                                <i class="fa fa-money"></i>
                            </span>
                            <div class="columns" style="width:100%">
                                <div class="column is-6">
                                    Iva:
                                </div>
                                <div class="column is-6">
                                    {{ctrl.dato.get('iva').value | currency:ctrl.configuracion.sucursal.moneda:'symbol'}}
                                </div>
                            </div>
                        </a>
                        <a class="panel-block">
                            <span class="panel-icon">
                                <i class="fa fa-money"></i>
                            </span>
                            <div class="columns" style="width:100%">
                                <div class="column is-6">
                                    Total:
                                </div>
                                <div class="column is-6">
                                    {{ctrl.dato.get('total').value | currency:ctrl.configuracion.sucursal.moneda:'symbol'}}

                                    <span *ngFor="let moneda of ctrl.configuracion.sucursal.conversiones_monedas" class="tag">

                                        <strong>
                                            <font>{{moneda.nombre}}</font>

                                        </strong>
                                        <font>
                                            {{(ctrl.dato.get('total').value / moneda.tipo_cambio) | currency:moneda.moneda:'symbol'}}
                                        </font>
                                    </span>
                                </div>
                            </div>
                        </a>
                        <a class="panel-block" *ngIf="ctrl.dato.get('total_recibido').value > 0">
                            <span class="panel-icon">
                                <i class="fa fa-money"></i>
                            </span>
                            <div class="columns" style="width:100%">
                                <div class="column is-6">
                                    Total recibido:
                                </div>
                                <div class="column is-6">
                                    {{ctrl.dato.get('total_recibido').value | currency:ctrl.configuracion.sucursal.moneda:'symbol'}}
                                </div>
                            </div>
                        </a>
                        <a class="panel-block" *ngIf="ctrl.dato.get('cambio').value > 0">
                            <span class="panel-icon">
                                <i class="fa fa-money"></i>
                            </span>
                            <div class="columns" style="width:100%">
                                <div class="column is-6">
                                    Cambio:
                                </div>
                                <div class="column is-6">
                                    {{ctrl.dato.get('cambio').value | currency:ctrl.configuracion.sucursal.moneda:'symbol'}}

                                    <span *ngFor="let moneda of ctrl.configuracion.sucursal.conversiones_monedas" class="tag">

                                        <strong>
                                            <font>{{moneda.nombre}}</font>

                                        </strong>
                                        <font>
                                            {{(ctrl.dato.get('cambio').value / moneda.tipo_cambio) | currency:moneda.moneda:'symbol'}}
                                        </font>

                                    </span>
                                </div>
                            </div>
                        </a>
                    </nav>

                </div>
            </div>
        </div>

    </div>
</form>

<div class="modal" id="abrirstock">
    <div class="modal-background"></div>
    <div class="modal-card" style="width:45%">
        <header class="modal-card-head">
            <h1>Lista de existencias</h1>
        </header>
        <section class="modal-card-body">
            <div class="content">
                <div class="field has-addons">
                    <div class="control has-icons-left is-expanded">
                        <input type="text" class="input is-flat is-medium" placeholder="Buscar" [(ngModel)]="busqueda" id="search-box">
                        <span class="icon is-medium is-left">
                            <i class="fa fa-search"></i>
                        </span>
                    </div>
                    <p class="control">
                        <button class="button is-medium is-primary" [ngClass]="{ 'is-disabled': busqueda==''}" (click)="busqueda=''">
                            <span class="icon">
                                <i class="fa fa-close"></i>
                            </span>
                        </button>
                    </p>
                </div>
                <table class="table is-striped">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Lote</th>
                            <th>Fecha de caducidad</th>
                            <th>Existencia</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of stocks | buscar: busqueda; let i=index">
                            <td>{{i + 1}}</td>
                            <td>{{item.lote}}</td>
                            <td>{{item.fecha_caducidad}}</td>
                            <td>{{item.existencia}}</td>
                            <td>
                                <a title="Surtir" class="button is-success" (click)="agregar_stock(item)">
                                    <span class="icon">
                                        <i class="fa fa-check"></i>
                                    </span>
                                </a>
                            </td>
                        </tr>
                    </tbody>
                </table>

            </div>
        </section>
        <footer class="modal-card-foot">

            <a class="button" (click)="ctrl.cancelarModal('abrirstock')" id='cancelar_stock'>Cancelar</a>
        </footer>
    </div>
</div>


<!-- colas si se guarda local hacer click despues de gaurdar para quitar el elemento de la lista si se guarda con crud es en automatico-->
<a (click)="ctrl.quitar_elemento_cola()" id="quitar_cola"></a>
<div class="modal" id="ventas_colas" *ngIf="ctrl.venta?.length > 0">
    <div class="modal-background"></div>
    <div class="modal-card" style="width:45%">
        <header class="modal-card-head">
            <h1>Lista de colas</h1>
        </header>
        <section class="modal-card-body">
            <div class="content">
                <div class="field has-addons">
                    <div class="control has-icons-left is-expanded">
                        <input type="text" class="input is-flat is-medium" placeholder="Buscar" [(ngModel)]="busqueda" id="search-box">
                        <span class="icon is-medium is-left">
                            <i class="fa fa-search"></i>
                        </span>
                    </div>
                    <p class="control">
                        <button class="button is-medium is-primary" [ngClass]="{ 'is-disabled': busqueda==''}" (click)="busqueda=''">
                            <span class="icon">
                                <i class="fa fa-close"></i>
                            </span>
                        </button>
                    </p>
                </div>
                <table class="table is-striped">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Cliente</th>
                            <th>Comentario</th>
                            <th>Importe</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of ctrl.venta | buscar: busqueda; let i=index">
                            <td>{{i + 1}}</td>
                            <td>
                                <select class="select" style=" border: none; background: transparent; " disabled>
                                    <option *ngFor="let pre of ctrl.clientes; let p = index" value="{{pre.id}}" [selected]="pre.id == item.personas_id">
                                        {{ pre.nombre }}
                                    </option>
                                </select>
                            </td>
                            <td>{{item.comentario}}</td>
                            <td>{{item.total | currency:ctrl.configuracion.sucursal.moneda:'symbol'}}</td>
                            <td>
                                <a title="Surtir" class="button is-success" (click)="ctrl.cargar_lista_colas(i, 'ventas_colas')">
                                    <span class="icon">
                                        <i class="fa fa-check"></i>
                                    </span>
                                </a>

                                <a title="Surtir" class="button is-danger" (click)="ctrl.quitar_lista_colas(i, 'ventas_colas')">
                                  <span class="icon ">
                                    <i class="fa fa-trash"></i>
                                  </span>
                                </a>
                            </td>
                        </tr>
                    </tbody>
                </table>

            </div>
        </section>
        <footer class="modal-card-foot">

            <a class="button" (click)="ctrl.cancelarModal('ventas_colas')" id="ventas_colas">Cancelar</a>
        </footer>
    </div>
</div>
